import React from 'react';
import Button from '../shared/Button';
import { KissMetrics } from '../../../shared/services';
import { LearnFinancingSubText, Bold } from './CarvanaLearnFinancing.styles';
import {
  Heading,
  FinancingDescription,
  ButtonWrapper,
  FinancingFAQLink
} from '../shared/Financing.styles';

function CarvanaLearnFinancing() {
  return (
    <>
      <Heading>Finance With Carvana</Heading>
      <FinancingDescription>
        <p>
          Financing with Carvana makes it even easier to get into the car that’s right for you. By
          pre-qualifying for a Carvana auto loan, you can browse our expansive inventory of vehicles
          with completely personalized financing terms without impacting your credit score.
        </p>
      </FinancingDescription>
      <ButtonWrapper>
        <Button
          href="/financing-prequalification"
          onClick={() => KissMetrics.trackEvent('Account - Finance - Clicked Get Prequalified')}
          small
        >
          Get Pre-Qualified
        </Button>
      </ButtonWrapper>
      <LearnFinancingSubText>
        <Bold>Have questions?</Bold>
        <FinancingFAQLink
          href="/help/payment-and-financing"
          onClick={() => KissMetrics.trackEvent('Account - Finance - Clicked FAQ')}
        >
          {' '}
          Get answers in a snap with our Finance FAQ
        </FinancingFAQLink>
      </LearnFinancingSubText>
    </>
  );
}

export default CarvanaLearnFinancing;
